// src-mlr/config.js

var mlrDevConfig = {
  production: false,
  appName: 'mlr',
  pubPath: 'mlr',
  baseURL: 'http://localhost:8086/',
  media: "https://media.mirasee/",
  api: "https://api.mirasee/v2/mlr/",
  apiv3: "http://localhost:8080/api/v3/",
};

var mlrProdConfig = {
  production: true,
  appName: 'mlr',
  pubPath: 'views',
  baseURL: 'https://motivationcoach.margaretlynchraniere.com',
  media: "https://media.mirasee.com/",
  api: "https://apimrs.margaretlynchraniere.com/",
  apiv3: "https://api.mirasee.com/v3/",
};

if (process.env.NODE_ENV == 'development')
  var mlrConfig = mlrDevConfig;
else
  mlrConfig = mlrProdConfig;

export default mlrConfig;
